<template>
    <!--
				Card - Contacts
    -->
    <div class="card-inner contacts" :class="{'active':$route.name=='Contact'}" id="contacts-card">
        <div class="card-wrap">
            <!--
						Conacts Info
            -->
            <div class="content contacts">
                <!-- title -->
                <div class="title">{{$t("contact.000")}}</div>

                <!-- content -->
                <div class="row">
                    <div class="col col-d-12 col-t-12 col-m-12 border-line-v">
                        <div class="map" id="map">
                            <baidu-map class="bm-view" center="台北市" :zoom="10" ak="E4805d16520de693a3fe707cdc962045">
                                <bm-boundary name="台北市" :strokeWeight="2" strokeColor="blue"></bm-boundary>
                                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                            </baidu-map>
                        </div>
                        <div class="info-list">
                            <ul>
                                <li>
                                    <strong>{{$t("contact.001")}} . . . . .</strong>
                                    {{$t("contact.002")}}
                                </li>
                                <li>
                                    <strong>{{$t("contact.003")}} . . . . .</strong> bedbjdem@gmail.com
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

            <!--
						Contact Form
            -->
            <div class="content contacts">
                <!-- title -->
                <div class="title">{{$t("contact.004")}}</div>

                <!-- content -->
                <div class="row">
                    <div class="col col-d-12 col-t-12 col-m-12 border-line-v">
                        <div class="contact_form">
                            <form method="post" target="_blank" action="https://formspree.io/bedbjdem@gmail.com">
                                <div class="row">
                                    <div class="col col-d-6 col-t-6 col-m-12">
                                        <div class="group-val">
                                            <input type="text" name="Sender" :placeholder="$t('contact.005')" />
                                        </div>
                                    </div>
                                    <div class="col col-d-6 col-t-6 col-m-12">
                                        <div class="group-val">
                                            <input type="email" name="email" :placeholder="$t('contact.006')" />
                                        </div>
                                    </div>
                                    <div class="col col-d-12 col-t-12 col-m-12">
                                        <div class="group-val">
                                            <textarea name="message" :placeholder="$t('contact.007')"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="align-left">
                                    <button
                                        style="border: solid;
                                            height: 4vh;
                                            width: 6vw;
                                            text-align: center;"
                                        type="submit"
                                    >
                                        <span class="text">{{$t('contact.009')}}</span>
                                        <span class="fas fa-paper-plane"></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmNavigation from "vue-baidu-map/components/controls/Navigation";
import BmBoundary from "vue-baidu-map/components/others/Boundary";
export default {
    methods: {},
    components: {
        BaiduMap,
        BmNavigation,
        BmBoundary
    }
};
</script>

<style lang="scss" scoped>
.bm-view {
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue